<div class="grid m-0 align-items-stretch">
    <div class="col-12">
        <h3 class="m-0 my-3 text-color">Individual Hazards</h3>
    </div>

    @if (analysis$ | async; as analysis) {
        @if (analysis.failedToLoad) {
            <div class="col-12">
                <app-empty-state
                    illustration="search"
                    title="Charts Could Not Load"
                    message="Something went wrong loading the hazard charts. Refresh the page to try again.">
                </app-empty-state>
            </div>
        } @else {
            @for (hazard of analysis.hazards; track hazard.hazardId) {
                <div class="col-12 flex align-items-baseline gap-2 mt-3">
                    <a
                        class="font-semibold"
                        [routerLink]="['/risk-management/hazard-register', hazard.hazardId]">
                        {{ hazard.publicId }}
                    </a>
                    <h4 class="m-0 text-color">{{ hazard.title }}</h4>
                </div>

                <div class="col-6 lg:col-3">
                    <app-card class="h-full" [showHeader]="false" [noMargin]="true">
                        <div card-body class="flex flex-column gap-1">
                            <span class="text-sm text-color-secondary">Total References</span>
                            <span class="text-2xl font-semibold text-color">{{ hazard.totalReferences }}</span>
                            @if (hazard.unlinkedReferences) {
                                <span class="text-xs text-color-secondary">{{ hazard.unlinkedReferences }} unlinked</span>
                            }
                        </div>
                    </app-card>
                </div>
                <div class="col-6 lg:col-3">
                    <app-card class="h-full" [showHeader]="false" [noMargin]="true">
                        <div card-body class="flex flex-column gap-1">
                            <span class="text-sm text-color-secondary">Linked Controls</span>
                            <span class="text-2xl font-semibold text-color">{{ hazard.linkedControls }}</span>
                        </div>
                    </app-card>
                </div>
                <div class="col-6 lg:col-3">
                    <app-card class="h-full" [showHeader]="false" [noMargin]="true">
                        <div card-body class="flex flex-column gap-1">
                            <span class="text-sm text-color-secondary">Control Effectiveness</span>
                            <span class="font-semibold text-color">{{ hazard.controlEffectiveness }}</span>
                        </div>
                    </app-card>
                </div>
                <div class="col-6 lg:col-3">
                    <app-card class="h-full" [showHeader]="false" [noMargin]="true">
                        <div card-body class="flex flex-column gap-1">
                            <span class="text-sm text-color-secondary">Next Reassessment</span>
                            <span class="font-semibold text-color">
                                {{ (hazard.nextReassessment | formatDateConditionalYear) || "Not set" }}
                            </span>
                        </div>
                    </app-card>
                </div>

                <div class="col-12 lg:col-4">
                    <app-stat-chart
                        class="w-full"
                        [variant]="'line'"
                        [title]="'References Over Time'"
                        [meta]="hazard.referencesOverTime.meta"
                        [customLegendItems]="hazard.referencesOverTime.legendItems ?? []"
                        [chartData]="hazard.referencesOverTime.chartData">
                    </app-stat-chart>
                </div>
                <div class="col-12 lg:col-4">
                    <app-stat-chart
                        class="w-full"
                        [variant]="'bars-vertical'"
                        [title]="'References by Source'"
                        [meta]="hazard.referencesBySource.meta"
                        [customLegendItems]="hazard.referencesBySource.legendItems ?? []"
                        [chartData]="hazard.referencesBySource.chartData">
                    </app-stat-chart>
                </div>
                <div class="col-12 lg:col-4">
                    <app-stat-chart
                        class="w-full"
                        [variant]="'bars-vertical'"
                        [title]="'Risk Level: Initial vs Residual'"
                        [meta]="hazard.riskLevelInitialVsResidual.meta"
                        [customLegendItems]="hazard.riskLevelInitialVsResidual.legendItems ?? []"
                        [chartData]="hazard.riskLevelInitialVsResidual.chartData">
                    </app-stat-chart>
                </div>
            } @empty {
                <div class="col-12">
                    <app-empty-state
                        illustration="search"
                        title="No Active Hazards"
                        message="There are no active hazards in the register for the selected filters.">
                    </app-empty-state>
                </div>
            }
        }
    } @else {
        <div class="col-12">
            <app-loading-indicator></app-loading-indicator>
        </div>
    }
</div>
